/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC } from 'react'
import { useFormikContext } from 'formik'
import SimpleLoader from '../../../apps/components/SimpleLoader';
import { MyEditor } from '../../../apps/components/MyEditor';
import CustomInputPreview from '../../../apps/components/CustomInputPreview';

type Props = {
  values: any,
  submitLoader: boolean;
  disableFormFields: boolean;
}

const ProjectCostSize: FC<Props> = ({ values, submitLoader, disableFormFields }) => {
  const { setFieldValue } = useFormikContext();

  return (
    <div className='w-100 position-relative'>
      {submitLoader && <SimpleLoader />}
      <div className='row mb-10 mt-5'>
        {/* <div className='col-md-6'>
          <label className='form-label'>Project Size</label>
          <CustomInputPreview
            value={values.financial_needs.project_size || ''}
          />
        </div>
        <div className='col-md-6'>
          <label className='form-label'>Project Type</label>
          <CustomInputPreview
            value={values.financial_needs.project_type || ''}
          />
        </div> */}
        <div className='col-6 mt-5'>
          <label className='form-label'>Estimated Cost</label>
          <CustomInputPreview
            value={values.financial_needs.project_cost || ''}
          />
        </div>
        <div className='col-md-12 mt-5'>
        <label className='form-label'>Financial Needs Summary</label>
          <MyEditor
            disabled={disableFormFields}
            value={values.financial_needs.project_cost_editor}
            setValue={(value: string) => {
              setFieldValue("financial_needs.project_cost_editor", value);
            }}
          />

        </div>
      </div>
    </div>
  )
}

export { ProjectCostSize }
